import { ApiService } from '../../constants';
import {HttpService, msalInstance} from '../../utilities';
import {
  SHOW_LOGIN_MODAL,
  FETCH_AUTH_USER,
  SET_AUTH_USER,
  SET_AUTH_FETCH,
  AUTH_USER_ERROR
} from './AuthTypes';

// TO BE MODIFIED CARA GET DARI HASIL AXIOS RESPONSE
// bentukan nya harus di map ke object biar ga return Promise Object
// Cek cara di OperationalAddDelete.tsx (BM7 Line 97)
export const showModal = (show: boolean) => async (dispatch: any) => {
  dispatch({
    type: SHOW_LOGIN_MODAL,
    payload: show
  });
};

export const setAuthUser =
  (username: string, password: string, azurePhoto?: string) =>
  async (dispatch: any) => {
    try {
      dispatch({
        type: FETCH_AUTH_USER
      });

      let url = ApiService.icdc.auth.getToken;
      let pass = null;
      let withAzure = true;

      if (password) {
        msalInstance.setActiveAccount(null);
        url = ApiService.icdc.auth.userLogin;
        pass = password;
        withAzure = false;
      }

      const authUser = HttpService.getAuthorizationToken(url, username, pass);

      let userData = null;
      await authUser.then((result) => {
        dispatch({
          type: SET_AUTH_USER,
          payload: null
        });

        if (result.data) {
          userData = result.data.data;
        }
      });

      if (userData) {
        dispatch({
          type: SET_AUTH_USER,
          payload: { ...userData, withAzure: withAzure, azurePhoto: azurePhoto }
        });
      }

      return userData;
    } catch (error: any) {
      dispatch({
        type: AUTH_USER_ERROR,
        payload: error.response ? error.response.statusText : error
      });

      return error;
    }
  };

export const setAuthFetch = () => async (dispatch: any) => {
  dispatch({
    type: SET_AUTH_FETCH
  });
};
